<template>
    <div v-if="submission.pairingId"
         class="Report__group-field-wrapper"
    >
        <div class="Report__field__submission">
            <v-text-field type="text"
                          readonly
                          label="Font Pairing"
                          v-model="pairing.name"
                          dense
                          outlined
            />
        </div>

        <div class="Report__field__submission" v-if="pairing.pairing">
            <v-text-field type="text"
                          readonly
                          label="Header Font"
                          v-model="pairing.pairing.h1.family"
                          dense
                          outlined
            />
            <v-btn icon small type="button" color="primary" v-clipboard="pairing.pairing.h1.family">
                <v-icon small>fas fa-copy</v-icon>
            </v-btn>
        </div>

        <div class="Report__field__submission" v-if="pairing.pairing">
            <v-text-field type="text"
                          readonly
                          label="Body Font"
                          v-model="pairing.pairing.body.family"
                          dense
                          outlined
            />
            <v-btn icon small type="button" color="primary" v-clipboard="pairing.pairing.body.family">
                <v-icon small>fas fa-copy</v-icon>
            </v-btn>
        </div>
    </div>

    <div v-else class="Report__group-field-wrapper">
        <div class="Report__field__submission">
            <v-text-field type="text"
                          readonly
                          label="Font Pairing"
                          v-model="customTitle"
                          dense
                          outlined
            />
        </div>

        <div class="Report__field__submission" v-if="submission.customPairing">
            <v-text-field type="text"
                          readonly
                          label="Header Font"
                          v-model="submission.customPairing.font_1"
                          dense
                          outlined
            />
            <v-btn icon small type="button" color="primary" v-clipboard="submission.customPairing.font_1">
                <v-icon small>fas fa-copy</v-icon>
            </v-btn>
        </div>

        <div class="Report__field__submission" v-if="submission.customPairing">
            <v-text-field type="text"
                          readonly
                          label="Body Font"
                          v-model="submission.customPairing.font_2"
                          dense
                          outlined
            />
            <v-btn icon small type="button" color="primary" v-clipboard="submission.customPairing.font_2">
                <v-icon small>fas fa-copy</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';
import axios from 'axios';

export default {
    mixins: [
        ReportFieldBoilerplate,
    ],

    data() {
        return {
            pairing: [],
            customTitle: 'Custom Fonts'
        };
    },

    mounted() {
        if (this.submission.pairingId) {
            this.getPaletteById();
        }
    },

    methods: {
        getPaletteById() {
            axios.get('/api/font-pairing/single/' + this.submission.pairingId)
                .then(response => {
                    this.pairing = response.data.data.pairing;
                });
        }
    }
};
</script>
<style lang="scss">
.Report__color-swatch {
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    margin-top: -1px;
    margin-left: 8px;
    box-shadow: 2px 2px 3px rgba(black, 0.2);
}
</style>
